angular.module('tgaAdmin').config([
  'envServiceProvider',
  function (envServiceProvider) {
    /**
     * Set the domains and variables for each environment.
     *
     * The `domains` object matches the host used to access the admin panel
     * (i.e. what's in the browser address bar) with a set of environment
     * variables (in the `vars` object).
     *
     * Each environment has 4 variables:
     *
     *   enableEvents: [boolean] - Whether or not to enable the "events" feature
     *     for this environment.
     *
     *   forceDomain: [false|string] - The name of a single API domain to use
     *     for all requests. If false, the API domain will be the first element
     *     of the period-separated host name (e.g. trainingarcade.local would
     *     become `?domain=trainingarcade`).
     *
     *   serverAddress: [string] - The full URL to the API endpoint to use
     *     (including port if non-default). This must be an HTTPS URL if the
     *     admin panel is being hosted over HTTPS.
     *
     *   slack_client_id: [string] - The Slack Client ID for creating Slack
     *     integration URLs.
     */
    envServiceProvider.config({
      domains: {
        testing: ['trainingarcade.com', 'thegameagencyportal.com'],
        production: ['thetrainingarcade.com'],
        staging: ['staging.thetrainingarcade.com'],
      },
      vars: {
        // Testing deployment
        testing: {
          enableEvents: true,
          forceDomain: false,
          serverAddress: 'https://tga-cms-backend.trainingarcade.com/api/v5/',
          // TODO: add real deployment address
          webSocketAddress: 'https://thegameagencyportal.com:8080/',
          slack_client_id: '255328402723.744855562247',
          gameUrlOverride: false,
        },
        // Staging deployment
        staging: {
          enableEvents: true,
          forceDomain: false,
          serverAddress: 'https://api.staging.thetrainingarcade.com/api/v5/',
          webSocketAddress: 'wss://mp.staging.thetrainingarcade.com',
          slack_client_id: '255328402723.744855562247',
          gameUrlOverride: false,
        },
        // Production deployment
        production: {
          enableEvents: false,
          forceDomain: false,
          serverAddress: 'https://api.thetrainingarcade.com/api/v5/',
          // TODO: add real deployment address
          webSocketAddress: 'wss://mp.thetrainingarcade.com',
          slack_client_id: '255328402723.757502739351',
          gameUrlOverride: false,
        },
      },
    });

    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();
  },
]);
